// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18UX3","footer":"styles_footer__2DujX","passCodeTooltip":"styles_passCodeTooltip__3gWDc"};